import React from 'react';
import PropTypes from 'prop-types';
import {Button, Form} from 'react-bootstrap';

const ExtensionAddendumSubmitMethod = ({
  disabled,
  value,
  icon,
  label,
  selected,
  setSubmitMethod,
}) => (
  <Button
    as="label"
    htmlFor={`eaSubmitBtn-${value}`}
    variant="outline-primary"
    className="submit-option-button border rounded mb-2 position-relative d-flex align-items-center w-100 bg-white text-black"
    disabled={disabled}
    onClick={() => {
      if (!disabled) {
        setSubmitMethod(value);
      }
    }}
  >
    <span className="me-3 text-primary">
      <i className={`fas ${icon}`} />
    </span>
    <Form.Check
      className="extend-addendum-button position-absolute"
      type="radio"
      id={`eaSubmitBtn-${value}`}
      value={value}
      checked={selected}
      disabled={disabled}
      readOnly
    />
    <Form.Label>{label}</Form.Label>
  </Button>
);

export default ExtensionAddendumSubmitMethod;

ExtensionAddendumSubmitMethod.propTypes = {
  disabled: PropTypes.bool.isRequired,
  value: PropTypes.string.isRequired,
  icon: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  selected: PropTypes.bool.isRequired,
  setSubmitMethod: PropTypes.func.isRequired,
};
